import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import CardSaldos from "../element/CardSaldos";
import CardPlanesPago from "../element/CardPlanesPago";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from './Footer';

const Saldos = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");
  const [saldos, setSaldos] = useState({});
  const [saldosPP, setSaldosPP] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      Promise.all([
        GetFetch.saldosAlumno(dataUser.carnet, dataUser.token),
        GetFetch.saldosPlanesPagoAlumno(dataUser.carnet, dataUser.token),
      ])
        .then(([saldosData, saldosDataPP]) => {
          setSaldos(saldosData);
          setSaldosPP(saldosDataPP);
          setCargando(false);
        })
        .catch(() => setCargando(false));

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  const listaSaldos = saldos.length > 0 ? saldos : [];
  const listaPP = saldosPP.length > 0 ? saldosPP : [];
  const totalSaldo = listaSaldos.reduce((s, e) => s + e.saldo, 0);
  const totalSaldoPP = listaPP.reduce((s, e) => s + e.monto, 0);
  const totalGeneral = totalSaldo + totalSaldoPP;
  const alDia = !cargando && listaSaldos.length === 0 && listaPP.length === 0;

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Saldos pendientes</h2>

        {cargando ? (
          <>
            <div className="esen-stat-grid">
              <SkeletonCard rows={1} title={false} />
              <SkeletonCard rows={1} title={false} />
            </div>
            <SkeletonCard rows={4} />
          </>
        ) : alDia ? (
          <EmptyState icon="fa-check-circle" title="Estás al día">
            No tienes saldos mensuales ni cuotas de planes de pago pendientes.
          </EmptyState>
        ) : (
          <>
            {/* Resumen financiero */}
            <div className="esen-stat-grid">
              <div className="esen-stat esen-stat--hero">
                <div>
                  <div className="esen-stat-value">${totalGeneral.toFixed(2)}</div>
                  <div className="esen-stat-label">Total pendiente de pago</div>
                </div>
              </div>
              <div className="esen-stat">
                <div>
                  <div className="esen-stat-value">${totalSaldo.toFixed(2)}</div>
                  <div className="esen-stat-label">
                    {listaSaldos.length} {listaSaldos.length === 1 ? 'mes pendiente' : 'meses pendientes'}
                  </div>
                </div>
              </div>
              {listaPP.length > 0 ? (
                <div className="esen-stat">
                  <div>
                    <div className="esen-stat-value">${totalSaldoPP.toFixed(2)}</div>
                    <div className="esen-stat-label">
                      {listaPP.length} {listaPP.length === 1 ? 'cuota de plan de pago' : 'cuotas de planes de pago'}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {listaPP.length > 0 ? (
              <div className="card">
                <div className="card-header">
                  <i className="fa fa-credit-card-alt mr-2" aria-hidden="true"></i>
                  Cuotas pendientes de planes de pago
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Cuota</th>
                          <th scope="col">Monto</th>
                          <th scope="col">Vencimiento</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaPP.map((element, i) => (
                          <CardPlanesPago
                            key={i}
                            cuota={element.cuota}
                            monto={element.monto}
                            vencimiento={element.vencimiento}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="card">
              <div className="card-header">
                <i className="fa fa-money mr-2" aria-hidden="true"></i>
                Meses pendientes de pago
              </div>
              <div className="card-body">
                {listaSaldos.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Concepto</th>
                          <th scope="col" className="text-right">Saldo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaSaldos.map((element, i) => (
                          <CardSaldos
                            key={i}
                            factura={element.factura}
                            concepto={element.concepto}
                            saldo={element.saldo}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted mb-0">No tienes saldos mensuales pendientes.</p>
                )}
              </div>
            </div>

            <a
              href="https://esen.edu.sv/finanzas/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              <i className="fa fa-external-link mr-2" aria-hidden="true"></i>
              Pagar en línea
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default Saldos;
